import { styled, css } from "styled-components";
import { CardVariant } from "./t-premia-card-types";
    
export const CardTitle = styled.h3`
    color: ${({ theme }) => theme?.colors?.text?.headings};
    font-family: "Red Hat Display", arial;
    font-size: 32px;
    font-weight: 700;
    margin: 0;
`;

export const CardDescription = styled.p`
    color: ${({ theme }) => theme?.colors?.text?.muted};
    font-size: 14px;
    line-height: 1.5;
    margin: 0;
`;

const variantStyles = {
    default: css`
        border: 1px solid ${({ theme }) => theme?.colors?.common?.white};
        background: ${({ theme }) => theme?.colors?.common?.white};  
        box-shadow: 0px 5px 32px 0px rgba(0, 67, 101, 0.08);
    `,
    featured: css`
        border: 2px solid ${({ theme }) => theme?.colors?.theme?.brandColor3};
        background: ${({ theme }) => theme?.colors?.common?.white};
        box-shadow: 0px 8px 40px 0px rgba(0, 67, 101, 0.12);
    `,
    transparent: css`
        background: transparent;
        border: none;
        box-shadow: none;
    `,
    outlined: css`
        border: 1px solid ${({ theme }) => theme?.colors?.text?.muted};
        background: transparent;
        box-shadow: none;
    `,
    dark: css`
        background: ${({ theme }) => theme?.colors?.theme?.contentBg};
        border: none;

        ${CardTitle} {
        color: ${({ theme }) => theme?.colors?.text?.headings};
        }
        ${CardDescription} {
        color: ${({ theme }) => theme?.colors?.text?.paragraphs};
        }
    `,
    blueGradient: css`
        background: linear-gradient(264deg, rgba(0, 85, 255, 0.50) 1.87%, rgba(0, 51, 153, 0.50) 99.83%);
        border: none;

        ${CardTitle} {
        color: ${({ theme }) => theme?.colors?.text?.headings};
        }
        ${CardDescription} {
        color: ${({ theme }) => theme?.colors?.text?.paragraphs};
        }
    `,
    gradientPurple: css`
        position: relative;
        background-color: ${({ theme }) => theme?.colors?.theme?.appBg};
        
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0.3;
            background: linear-gradient(180deg, rgba(141, 13, 242, 0.50) 0%, rgba(141, 13, 242, 0.00) 100%);
            z-index: 0;
            pointer-events: none;
        }

        & > * {
            position: relative;
            z-index: 1;
        }
    `
};

export const CardWrapper = styled.div<{ $variant?: CardVariant }>`
    width: 100%;
    border-radius: ${({ theme }) => theme?.sizes?.borderRadius?.card};
    display: flex;
    flex-direction: column;
    overflow: visible;
    transition: transform 0.2s ease-in-out;
    padding: ${({ theme }) => theme?.sizes?.padding?.card};

    ${({ $variant = 'default' }) => variantStyles[$variant]}
    box-sizing: border-box;
    @media (max-width: 768px) {
        border-radius: 32px;
    }
`;

export const CardImage = styled.img`
    width: 100%;
    height: 200px;
    object-fit: cover;
`;

export const CardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
`;


export const CardHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;